import { Breakpoint, ButtonType, Typography, UiComponentSize } from '@altibox/design-system-component-lib';
// eslint-disable-next-line import/no-unresolved
import { ButtonProps } from '@altibox/design-system-component-lib/dist/components/button/button';
import { castArray } from 'lodash';
import React, { FC, ReactNode } from 'react';

import { DataLayerErrorWrapper } from 'src/components/data-layer-wrapper/data-layer-error-wrapper';
import { ImageProps } from 'src/components/image';
import { Link } from 'src/components/link';
import { config } from 'src/config';
import { i18n } from 'src/i18n';
import { navigationService } from 'src/services/navigation-service';
import { I18nUtils } from 'src/utils/i18n-utils';

import { StyledButton, StyledContainer, StyledImage, StyledSubtitle } from './common-error.styled';

interface Props {
  title: string;
  subtitles: ReactNode | ReactNode[];
  image: ImageProps;
  hideCustomerServiceText?: boolean;
  dataLayerErrorMessage: string;
  buttonOptions?: Pick<ButtonProps, 'onClick' | 'children'>;
}

export const CommonError: FC<Props> = (props) => {
  const {
    title,
    subtitles,
    image,
    hideCustomerServiceText,
    dataLayerErrorMessage,
    buttonOptions = {
      onClick: navigationService.goToMineSider,
      children: i18n.component.commonError.goToMineSider,
    },
  } = props;

  const renderContactCustomerService = () =>
    I18nUtils.richMessage(i18n.component.commonError.contactCustomerService, {
      linkToCustomerService: (
        <Link variant="paragraph2" maxBreakpoint={Breakpoint.TABLET} target="_blank" href={config.CUSTOMER_SERVICE_URL}>
          {i18n.component.commonError.linkToCustomerService}
        </Link>
      ),
    });

  const handleButtonClick = buttonOptions.onClick;

  return (
    <DataLayerErrorWrapper errorMessage={dataLayerErrorMessage}>
      <StyledContainer>
        <Typography variant="headline2" component="h1">
          {title}
        </Typography>
        <StyledImage {...image} />
        {castArray(subtitles).map((subtitle, index) => (
          <StyledSubtitle variant="paragraph2" component="p" key={index}>
            {subtitle}
          </StyledSubtitle>
        ))}
        {!hideCustomerServiceText && (
          <StyledSubtitle variant="paragraph2" component="p">
            {renderContactCustomerService()}
          </StyledSubtitle>
        )}
        <StyledButton
          buttonType={ButtonType.PRIMARY_A}
          uiComponentSize={UiComponentSize.LARGE}
          onClick={handleButtonClick}
        >
          {buttonOptions.children}
        </StyledButton>
      </StyledContainer>
    </DataLayerErrorWrapper>
  );
};
